import React from "react";
import TspStoryListPage from "../stories/TspStoryListPage";

// Blogs (/tsp/blogs): tips, lessons and travel notes written by the parties.
// Same screen as Success Stories, scoped to the blog categories.
export default function TspBlogsPage() {
  return <TspStoryListPage kind="blog" />;
}
